import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { LoginMagic, LoginOTP } from "@/features/auth";
import { ConfigProvider, fetchConfig } from "@/lib/config";
import { fetchUser } from "@/lib/user";

export const Route = createFileRoute("/login-action")({
  component: RouteComponent,
  beforeLoad: async () => {
    const [user, config] = await Promise.all([fetchUser(), fetchConfig()]);
    if (user) {
      throw redirect({ to: "/" });
    }

    return { config };
  },
  validateSearch: z.object({
    type: z.enum(["magic", "otp"]),
    email: z.string().optional(),
  }),
});

function RouteComponent() {
  const { config } = Route.useRouteContext();
  const search = Route.useSearch();
  return (
    <ConfigProvider config={config}>
      {search.type === "magic" ? (
        <LoginMagic email={search.email} />
      ) : (
        <LoginOTP email={search.email} />
      )}
    </ConfigProvider>
  );
}
